export var Locale;

(function (Locale) {
  Locale["EN"] = "EN";
  Locale["PL"] = "PL";
  Locale["DE"] = "DE";
})(Locale || (Locale = {}));